import { styled, keyframes } from '@mui/material';
import { ColorSAP } from '../../ontego-ui';

const infiniteRotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const Styled = {};

Styled.Backdrop = styled("div")(() => ({
    zIndex: 100000,
    background: `rgba(0, 82, 127, 0.8)`,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    overflow: "hidden"
}));

Styled.Loading = styled("div")(() => ({
    '& svg': {
        width: 104,
        height: 104,
        color: ColorSAP.primary[40],
        animation: `${infiniteRotate} 1s linear infinite`,
    }
}));

export default Styled;